import config from "@/config";
import http from "@/utils/request";

export default {
	actionLog: {
		list: {
			url: `${config.API_URL}/admin/action_log/getList`,
			name: "用户登录记录",
			get: async function (params = {}, config = {}) {
				return await http.get(this.url, params, config);
			},
		},
	},
	user: {
		list: {
			url: `${config.API_URL}/admin/user/getUserList`,
			name: "用户列表",
			get: async function (params) {
				return await http.get(this.url, params);
			},
		},
		mergeUser: {
			url: `${config.API_URL}/admin/user/mergeUser`,
			name: "合并用户",
			get: async function (params) {
				return await http.get(this.url, params);
			},
		},
		getSmsCode: {
			url: `${config.API_URL}/admin/user/getSmsCode`,
			name: "获取短信验证码",
			get: async function (params) {
				return await http.get(this.url, params);
			},
		},
		subordinate: {
			list: {
				url: `${config.API_URL}/admin/user/getSubordinateList`,
				name: "用户团队列表",
				get: async function (params) {
					return await http.get(this.url, params);
				},
			},
			tree: {
				url: `${config.API_URL}/admin/user/getSubordinateTree`,
				name: "用户团队树状图",
				get: async function (params) {
					return await http.get(this.url, params);
				},
			},
		},
		getUserListQuery: {
			url: `${config.API_URL}/admin/user/getUserListQuery`,
			name: "获取用户列表查询",
			get: async function (params) {
				return await http.get(this.url, params);
			},
		},
		edit: {
			url: `${config.API_URL}/admin/mini_user/store`,
			name: "新增/编辑用户",
			post: async function (params) {
				return await http.post(this.url, params);
			},
		},
		detail: {
			url: `${config.API_URL}/admin/mini_user/show`,
			name: "用户详情",
			post: async function (params) {
				return await http.post(this.url, params);
			},
		},
		record: {
			url: `${config.API_URL}/admin/user/record`,
			name: "获取用户记录列表",
			get: async function (params) {
				return await http.get(this.url, params);
			},
		},
		export: {
			url: `${config.API_URL}/admin/user/getUserList`,
			name: "导出用户列表",
			get: async function (params, config = {}) {
				return await http.get(this.url, params, config);
			},
		},
		recharge: {
			url: `${config.API_URL}/admin/mini_user/recharge`,
			name: "赠送余额",
			post: async function (params) {
				return await http.post(this.url, params);
			},
		},
		levelLog: {
			url: `${config.API_URL}/api/ly/level/change/approval/log/page`,
			name: "用户等级日志",
			get: async function (params) {
				return await http.get(this.url, params);
			},
		},
		referrerLog: {
			url: `${config.API_URL}/api/ly/referrer/change/log/page`,
			name: "用户推荐关系日志",
			get: async function (params) {
				return await http.get(this.url, params);
			},
		},
		watchRecord: {
			url: `${config.API_URL}/app/time/getChapter`,
			name: "用户观看记录",
			post: async function (params) {
				return await http.post(this.url, params);
			},
		},
		studyRecord: {
			addChapter: {
				url: `${config.API_URL}/app/time/addChapter`,
				name: "新增学习记录",
				post: async function (params) {
					return await http.post(this.url, params);
				},
			},
			chapterList: {
				url: `${config.API_URL}/app/time/chapterList`,
				name: "获取课程列表",
				post: async function (params) {
					return await http.post(this.url, params);
				},
			},
			deleteChapter: {
				url: `${config.API_URL}/app/time/deleteChapter`,
				name: "删除学习记录",
				post: async function (params) {
					return await http.post(this.url, params);
				},
			},
		},
		materialRecord: {
			list: {
				url: `${config.API_URL}/app/time/getEnroll`,
				name: "资料领取列表",
				post: async function (params) {
					return await http.post(this.url, params);
				},
			},
			add: {
				url: `${config.API_URL}/app/time/addEnroll`,
				name: "新增资料领取记录",
				post: async function (params) {
					return await http.post(this.url, params);
				},
			},
			delete: {
				url: `${config.API_URL}/app/time/deleteEnroll`,
				name: "删除资料领取记录",
				post: async function (params) {
					return await http.post(this.url, params);
				},
			},
		},
		getUserBank: {
			url: `${config.API_URL}/admin/user/getUserBank`,
			name: "获取用户银行卡",
			get: async function (params) {
				return await http.get(this.url, params);
			},
		},
		storeUserBank: {
			url: `${config.API_URL}/admin/user/storeUserBank`,
			name: "保存用户银行卡",
			post: async function (params) {
				return await http.post(this.url, params);
			},
		},
		updateUserBankCardDefault: {
			url: `${config.API_URL}/admin/user/updateUserBankCardDefault`,
			name: "设置默认银行卡",
			post: async function (params) {
				return await http.post(this.url, params);
			},
		},
		// 线上收款账户
		getUserMerchantInfoList: {
			url: `${config.API_URL}/admin/user/getUserMerchantInfoList`,
			name: "获取线上收款账户列表",
			get: async function (params) {
				return await http.get(this.url, params);
			},
		},
		storeUserMerchantInfo: {
			url: `${config.API_URL}/admin/user/storeUserMerchantInfo`,
			name: "新增/编辑线上收款账户",
			post: async function (params) {
				return await http.post(this.url, params);
			},
		},
		updateUserMerchantInfoDefault: {
			url: `${config.API_URL}/admin/user/updateUserMerchantInfoDefault`,
			name: "设置默认线上收款账户",
			post: async function (params) {
				return await http.post(this.url, params);
			},
		},
		updateUserMerchantInfoReceipt: {
			url: `${config.API_URL}/admin/user/updateUserMerchantInfoReceipt`,
			name: "设置邮件已回执",
			post: async function (params) {
				return await http.post(this.url, params);
			},
		},
		// 邀约入群记录
		inviteJoinGroupRecord: {
			add: {
				url: `${config.API_URL}/admin/user/addInviteJoinGroupRecord`,
				name: "添加邀约入群记录",
				post: async function (params) {
					return await http.post(this.url, params);
				},
			},
			list: {
				url: `${config.API_URL}/admin/user/inviteJoinGroupRecordLists`,
				name: "邀约入群记录列表",
				get: async function (params) {
					return await http.get(this.url, params);
				},
			},
			delete: {
				url: `${config.API_URL}/admin/user/inviteJoinGroupRecordDelete`,
				name: "删除邀约入群记录",
				get: async function (params) {
					return await http.get(this.url, params);
				},
			},
		},
	},
	scrm: {
		trajectory: {
			url: `${config.API_URL}/api/system/area/getTrajectory`,
			name: "用户动态",
			get: async function (userId, phone, idNumber, trajectoryType) {
				return await http.get(
					`${this.url}?userId=${userId}&phone=${phone}&idNumber=${idNumber}&trajectoryType=${trajectoryType}`
				);
			},
		},
	},
	label: {
		list: {
			url: `${config.API_URL}/admin/label/list`,
			name: "标签列表",
			get: async function (params) {
				return await http.get(this.url, params);
			},
		},
		addAndEdit: {
			url: `${config.API_URL}/admin/label/store`,
			name: "新增/编辑标签",
			post: async function (params) {
				return await http.post(this.url, params);
			},
		},
		delete: {
			url: `${config.API_URL}/admin/label/del`,
			name: "删除标签",
			get: async function (params) {
				return await http.get(this.url, params);
			},
		},
	},
	black: {
		list: {
			url: `${config.API_URL}/admin/roster/blackList`,
			name: "黑名单列表",
			get: async function (params) {
				return await http.get(this.url, params);
			},
		},
		importFile: {
			url: `${config.API_URL}/admin/roster/importBlack`,
			name: "导入",
			post: async function (data, config = {}) {
				return await http.post(this.url, data, config);
			},
		},
		delete: {
			url: `${config.API_URL}/admin/roster/delBlack`,
			name: "删除黑名单",
			get: async function (params) {
				return await http.get(this.url, params);
			},
		},
		template: {
			url: `${config.API_URL}/admin/roster/template`,
			name: "导入模板",
			get: async function (params) {
				return await http.get(this.url, params);
			},
		},
	},
	ignored: {
		list: {
			url: `${config.API_URL}/admin/roster/ignoredList`,
			name: "免打扰列表",
			get: async function (params) {
				return await http.get(this.url, params);
			},
		},
		importFile: {
			url: `${config.API_URL}/admin/roster/importIgnored`,
			name: "导入",
			post: async function (data, config = {}) {
				return await http.post(this.url, data, config);
			},
		},
		delete: {
			url: `${config.API_URL}/admin/roster/delIgnored`,
			name: "删除免打扰",
			get: async function (params) {
				return await http.get(this.url, params);
			},
		},
	},
	auxiliaryNumber: {
		list: {
			url: `${config.API_URL}/admin/mini_user/auxiliaryNumberList`,
			name: "辅助号列表",
			get: async function (params) {
				return await http.get(this.url, params);
			},
		},
		add: {
			url: `${config.API_URL}/admin/mini_user/addAuxiliaryNumber`,
			name: "新增",
			post: async function (params) {
				return await http.post(this.url, params);
			},
		},
		default: {
			url: `${config.API_URL}/admin/mini_user/setDefaultAuxiliaryNumber`,
			name: "设为默认",
			post: async function (params) {
				return await http.post(this.url, params);
			},
		},
		unbind: {
			url: `${config.API_URL}/admin/mini_user/unbindAuxiliaryNumber`,
			name: "解绑",
			post: async function (params) {
				return await http.post(this.url, params);
			},
		},
		bindLucky: {
			url: `${config.API_URL}/admin/mini_user/bindLuckyNumber`,
			name: "绑定吉祥号",
			post: async function (params) {
				return await http.post(this.url, params);
			},
		},
		unbindLucky: {
			url: `${config.API_URL}/admin/mini_user/unbindLuckyNumber`,
			name: "解绑吉祥号",
			post: async function (params) {
				return await http.post(this.url, params);
			},
		},
	},
	member: {
		list: {
			url: `${config.API_URL}/admin/member_level/index`,
			name: "获取会员列表",
			get: async function (params) {
				return await http.get(this.url, params);
			},
		},
		detail: {
			url: `${config.API_URL}/admin/member_level/show`,
			name: "会员详情",
			get: async function (params) {
				return await http.get(this.url, params);
			},
		},
		addAndEdit: {
			url: `${config.API_URL}/admin/member_level/store`,
			name: "新增/编辑会员等级",
			post: async function (params) {
				return await http.post(this.url, params);
			},
		},
	},
	group: {
		list: {
			url: `${config.API_URL}/admin/organization/list`,
			name: "获取分院列表",
			get: async function (params) {
				return await http.get(this.url, params);
			},
		},
		addAndEdit: {
			url: `${config.API_URL}/admin/organization/store`,
			name: "新增/编辑分院",
			post: async function (params) {
				return await http.post(this.url, params);
			},
		},
		delete: {
			url: `${config.API_URL}/admin/organization/del`,
			name: "删除分院",
			post: async function (params) {
				return await http.post(this.url, params);
			},
		},
	},
	// 区号列表
	countryCode: {
		url: `${config.API_URL}/admin/mini_user/getCountryCode`,
		name: "区号列表",
		get: async function (params) {
			return await http.get(this.url, params);
		},
	},
	level: {
		list: {
			url: `${config.API_URL}/admin/user_level/index`,
			name: "获取用户等级列表",
			get: async function (params) {
				return await http.get(this.url, params);
			},
		},
		addAndEdit: {
			url: `${config.API_URL}/admin/user_level/store`,
			name: "新增/编辑用户等级",
			post: async function (params) {
				return await http.post(this.url, params);
			},
		},
		detail: {
			url: `${config.API_URL}/admin/user_level/show`,
			name: "用户等级详情",
			get: async function (params) {
				return await http.get(this.url, params);
			},
		},
		delete: {
			url: `${config.API_URL}/admin/user_level/del`,
			name: "删除用户等级",
			post: async function (params) {
				return await http.post(this.url, params);
			},
		},
		updataStatus: {
			url: `${config.API_URL}/admin/user_level/enable`,
			name: "修改用户等级状态",
			post: async function (params) {
				return await http.post(this.url, params);
			},
		},
	},
	identity: {
		list: {
			url: `${config.API_URL}/admin/agent/index`,
			name: "获取合作伙伴列表",
			post: async function (params) {
				return await http.post(this.url, params);
			},
		},
		audit: {
			url: `${config.API_URL}/admin/agent/enable`,
			name: "合作伙伴审核",
			post: async function (params) {
				return await http.post(this.url, params);
			},
		},
		addLucky: {
			url: `${config.API_URL}/app/identity/addLucky`,
			name: "新增吉祥号",
			get: async function (params) {
				return await http.get(this.url, params);
			},
		},
	},
	config: {
		detail: {
			url: `${config.API_URL}/admin/config/show`,
			name: "获取用户配置信息",
			post: async function (params) {
				return await http.post(this.url, params);
			},
		},
		save: {
			url: `${config.API_URL}/admin/config/store`,
			name: "保存用户配置信息",
			post: async function (params) {
				return await http.post(this.url, params);
			},
		},
	},
	lesson: {
		list: {
			url: `${config.API_URL}/admin/course_category/list`,
			name: "课程分类列表",
			get: async function (params) {
				return await http.get(this.url, params);
			},
		},
		addAndEdit: {
			url: `${config.API_URL}/admin/course_category/store`,
			name: "新增/编辑程分类",
			post: async function (params) {
				return await http.post(this.url, params);
			},
		},

		area: {
			url: `${config.API_URL}/admin/course_area/list`,
			name: "课程领域列表",
			get: async function (params) {
				return await http.get(this.url, params);
			},
		},
		areaAddAndEdit: {
			url: `${config.API_URL}/admin/course_area/store`,
			name: "新增/编辑课程领域",
			post: async function (params) {
				return await http.post(this.url, params);
			},
		},
		label: {
			url: `${config.API_URL}/admin/label/list`,
			name: "课程标签列表",
			get: async function (params) {
				return await http.get(this.url, params);
			},
		},
		labelAddAndEdit: {
			url: `${config.API_URL}/admin/label/store`,
			name: "新增/编辑课程标签",
			post: async function (params) {
				return await http.post(this.url, params);
			},
		},
		lecturerList: {
			url: `${config.API_URL}/admin/lecturer/list`,
			name: "讲师列表",
			get: async function (params) {
				return await http.get(this.url, params);
			},
		},
		lecturerAddAndEdit: {
			url: `${config.API_URL}/admin/lecturer/store`,
			name: "新增/编辑讲师",
			post: async function (params) {
				return await http.post(this.url, params);
			},
		},
		lecturerDetail: {
			url: `${config.API_URL}/admin/lecturer/detail`,
			name: "讲师详情",
			get: async function (params) {
				return await http.get(this.url, params);
			},
		},
		lessonList: {
			url: `${config.API_URL}/admin/course/list`,
			name: "线上课程列表",
			get: async function (params) {
				return await http.get(this.url, params);
			},
		},
		lessonDetail: {
			url: `${config.API_URL}/admin/course/getDetail`,
			name: "线上课程详情",
			get: async function (params) {
				return await http.get(this.url, params);
			},
		},
		delete: {
			url: `${config.API_URL}/admin/course/del`,
			name: "删除线上课程",
			post: async function (params) {
				return await http.post(this.url, params);
			},
		},
		delChapter: {
			url: `${config.API_URL}/admin/course/delChapter`,
			name: "删除线上课程章节",
			post: async function (params) {
				return await http.post(this.url, params);
			},
		},
		lecturerdel: {
			url: `${config.API_URL}/admin/lecturer/del`,
			name: "删除讲师",
			post: async function (params) {
				return await http.post(this.url, params);
			},
		},
		lessondel: {
			url: `${config.API_URL}/admin/offline_course/del`,
			name: "删除线下课程",
			get: async function (params) {
				return await http.get(this.url, params);
			},
		},
		outlineDetail: {
			url: `${config.API_URL}/admin/offline_course/getDetail`,
			name: "线下课程详情",
			get: async function (params) {
				return await http.get(this.url, params);
			},
		},
		lessonAddAndEdit: {
			url: `${config.API_URL}/admin/course/store`,
			name: "新增/编辑线上课程列表",
			post: async function (params) {
				return await http.post(this.url, params);
			},
		},
		storeCourseChapter: {
			url: `${config.API_URL}/admin/course/storeCourseChapter`,
			name: "章节目录",
			post: async function (params) {
				return await http.post(this.url, params);
			},
		},
		offlineLessonList: {
			url: `${config.API_URL}/admin/offline_course/list`,
			name: "线下课程列表",
			get: async function (params) {
				return await http.get(this.url, params);
			},
		},
		courseList: {
			url: `${config.API_URL}/admin/offline_course/getUserOfflineCourseList`,
			name: "报名记录",
			get: async function (params, config = {}) {
				return await http.get(this.url, params, config);
			},
		},
		batchUpdateUserOfflineCourse: {
			url: `${config.API_URL}/admin/offline_course/batchUpdateUserOfflineCourse`,
			name: "批量核销报名记录",
			post: async function (params) {
				return await http.post(this.url, params);
			},
		},

		offlineLessonAddAndEdit: {
			url: `${config.API_URL}/admin/offline_course/store`,
			name: "新增/编辑线下课程列表",
			post: async function (params) {
				return await http.post(this.url, params);
			},
		},
		card: {
			list: {
				url: `${config.API_URL}/admin/card/list`,
				name: "复训卡列表",
				get: async function (params) {
					return await http.get(this.url, params);
				},
			},
			detail: {
				url: `${config.API_URL}/admin/card/detail`,
				name: "复训卡详情",
				get: async function (params) {
					return await http.get(this.url, params);
				},
			},
			delete: {
				url: `${config.API_URL}/admin/card/del`,
				name: "删除复训卡",
				get: async function (params) {
					return await http.get(this.url, params);
				},
			},
			addAndEdit: {
				url: `${config.API_URL}/admin/card/store`,
				name: "新增/编辑复训卡",
				post: async function (params) {
					return await http.post(this.url, params);
				},
			},
			give: {
				url: `${config.API_URL}/admin/user/giveCard`,
				name: "赠送卡项",
				post: async function (params) {
					return await http.post(this.url, params);
				},
			},
		},
	},
	activity_category: {
		list: {
			url: `${config.API_URL}/admin/activity_category/list`,
			name: "线下课列表",
			get: async function (params) {
				return await http.get(this.url, params);
			},
		},
		addAndEdit: {
			url: `${config.API_URL}/admin/activity_category/store`,
			name: "新增/编辑线下课",
			post: async function (params) {
				return await http.post(this.url, params);
			},
		},
		delete: {
			url: `${config.API_URL}/admin/activity_category/del`,
			name: "删除线下课",
			get: async function (params) {
				return await http.get(this.url, params);
			},
		},
	},
	online: {
		list: {
			url: `${config.API_URL}/admin/online_classes/list`,
			name: "线上课列表",
			get: async function (params) {
				return await http.get(this.url, params);
			},
		},
		addAndEdit: {
			url: `${config.API_URL}/admin/online_classes/store`,
			name: "新增/编辑线下课",
			post: async function (params) {
				return await http.post(this.url, params);
			},
		},
		detail: {
			url: `${config.API_URL}/admin/online_classes/getDetail`,
			name: "线上课详情",
			get: async function (params) {
				return await http.get(this.url, params);
			},
		},
		delete: {
			url: `${config.API_URL}/admin/activity_category/del`,
			name: "删除线下课",
			get: async function (params) {
				return await http.get(this.url, params);
			},
		},
		ChapterList: {
			url: `${config.API_URL}/admin/online_classes/courseChapterList`,
			name: "章节列表",
			get: async function (params) {
				return await http.get(this.url, params);
			},
		},
		ChapterAddAndEdit: {
			url: `${config.API_URL}/admin/online_classes/storeCourseChapter`,
			name: "新增/编辑章节",
			post: async function (params) {
				return await http.post(this.url, params);
			},
		},
		ChapterDel: {
			url: `${config.API_URL}/admin/online_classes/delChapter`,
			name: "删除章节",
			get: async function (params) {
				return await http.get(this.url, params);
			},
		},
	},
	formula: {
		list: {
			url: `${config.API_URL}/admin/formula/list`,
			name: "配方列表",
			get: async function (params) {
				return await http.get(this.url, params);
			},
		},
		addAndEdit: {
			url: `${config.API_URL}/admin/formula/store`,
			name: "新增/编辑配方",
			post: async function (params) {
				return await http.post(this.url, params);
			},
		},
		detail: {
			url: `${config.API_URL}/admin/formula/detail`,
			name: "配方详情",
			get: async function (params) {
				return await http.get(this.url, params);
			},
		},
		proposeAddAndEdit: {
			url: `${config.API_URL}/admin/formula/formulaProposeStore`,
			name: "新增/编辑建议配方",
			post: async function (params) {
				return await http.post(this.url, params);
			},
		},
		delete: {
			url: `${config.API_URL}/admin/formula/del`,
			name: "删除配方",
			post: async function (params) {
				return await http.post(this.url, params);
			},
		},
	},
	wiki: {
		list: {
			url: `${config.API_URL}/admin/wiki/list`,
			name: "百科列表",
			get: async function (params) {
				return await http.get(this.url, params);
			},
		},
		addAndEdit: {
			url: `${config.API_URL}/admin/wiki/store`,
			name: "新增/编辑百科",
			post: async function (params) {
				return await http.post(this.url, params);
			},
		},
		detail: {
			url: `${config.API_URL}/admin/wiki/detail`,
			name: "百科详情",
			get: async function (params) {
				return await http.get(this.url, params);
			},
		},
		delete: {
			url: `${config.API_URL}/admin/wiki/del`,
			name: "删除百科",
			post: async function (params) {
				return await http.post(this.url, params);
			},
		},
	},
	formulacate: {
		list: {
			url: `${config.API_URL}/admin/category/list`,
			name: "配方/百科分类列表",
			get: async function (params) {
				return await http.get(this.url, params);
			},
		},
		addAndEdit: {
			url: `${config.API_URL}/admin/category/store`,
			name: "新增/编辑配方/百科分类",
			post: async function (params) {
				return await http.post(this.url, params);
			},
		},
		delete: {
			url: `${config.API_URL}/admin/category/del`,
			name: "删除分类",
			post: async function (params) {
				return await http.post(this.url, params);
			},
		},
	},
	formulaout: {
		list: {
			url: `${config.API_URL}/admin/formula/getFormulaStockFlow`,
			name: "库存流水列表",
			get: async function (params) {
				return await http.get(this.url, params);
			},
		},
		addAndEdit: {
			url: `${config.API_URL}/admin/formula/operateFormulaStock`,
			name: "新增/编辑库存流水",
			post: async function (params) {
				return await http.post(this.url, params);
			},
		},
		delete: {
			url: `${config.API_URL}/admin/formula/getFormulaStockFlow`,
			name: "删除分类",
			post: async function (params) {
				return await http.post(this.url, params);
			},
		},
	},
	advert: {
		list: {
			url: `${config.API_URL}/admin/advert/list`,
			name: "广告列表",
			get: async function (params) {
				return await http.get(this.url, params);
			},
		},
		addAndEdit: {
			url: `${config.API_URL}/admin/advert/store`,
			name: "新增/编辑广告",
			post: async function (params) {
				return await http.post(this.url, params);
			},
		},
		delete: {
			url: `${config.API_URL}/admin/advert/del`,
			name: "删除广告",
			post: async function (params) {
				return await http.post(this.url, params);
			},
		},
	},
	kingkong: {
		list: {
			url: `${config.API_URL}/admin/kingkong/list`,
			name: "金刚区列表",
			get: async function (params) {
				return await http.get(this.url, params);
			},
		},
		addAndEdit: {
			url: `${config.API_URL}/admin/kingkong/store`,
			name: "新增/编辑金刚区",
			post: async function (params) {
				return await http.post(this.url, params);
			},
		},
	},
	banner: {
		list: {
			url: `${config.API_URL}/admin/banner/list`,
			name: "banner列表",
			get: async function (params) {
				return await http.get(this.url, params);
			},
		},
		addAndEdit: {
			url: `${config.API_URL}/admin/banner/store`,
			name: "新增/编辑banner",
			post: async function (params) {
				return await http.post(this.url, params);
			},
		},
		delete: {
			url: `${config.API_URL}/admin/banner/del`,
			name: "删除banner",
			get: async function (params) {
				return await http.get(this.url, params);
			},
		},
	},
	problem: {
		list: {
			url: `${config.API_URL}/admin/problem/list`,
			name: "问题列表",
			get: async function (params) {
				return await http.get(this.url, params);
			},
		},
		addAndEdit: {
			url: `${config.API_URL}/admin/problem/store`,
			name: "新增/编辑问题",
			post: async function (params) {
				return await http.post(this.url, params);
			},
		},
		delete: {
			url: `${config.API_URL}/admin/problem/del`,
			name: "删除问题",
			post: async function (params) {
				return await http.post(this.url, params);
			},
		},
	},
	agreement: {
		list: {
			url: `${config.API_URL}/admin/agreement/list`,
			name: "协议列表",
			get: async function (params) {
				return await http.get(this.url, params);
			},
		},
		addAndEdit: {
			url: `${config.API_URL}/admin/agreement/store`,
			name: "新增/编辑协议",
			post: async function (params) {
				return await http.post(this.url, params);
			},
		},
	},
	userlist: {
		list: {
			url: `${config.API_URL}/admin/user/getUserList`,
			name: "用户列表",
			get: async function (params) {
				return await http.get(this.url, params);
			},
		},
		searchAgent: {
			url: `${config.API_URL}/admin/user/searchAgent`,
			name: "搜索结缘人",
			get: async function (params) {
				return await http.get(this.url, params);
			},
		},
	},
	withdrawa: {
		list: {
			url: `${config.API_URL}/admin/withdrawal/index`,
			name: "提现列表",
			post: async function (params) {
				return await http.get(this.url, params);
			},
		},
		addAndEdit: {
			url: `${config.API_URL}/admin/withdrawal/store`,
			name: "提现审核",
			post: async function (params) {
				return await http.post(this.url, params);
			},
		},
		detail: {
			url: `${config.API_URL}/admin/withdrawal/show`,
			name: "提现详情",
			get: async function (params) {
				return await http.get(this.url, params);
			},
		},
		getWithdrawalConfig: {
			url: `${config.API_URL}/admin/withdrawal/getWithdrawalConfig`,
			name: "获取提现配置",
			get: async function (params) {
				return await http.get(this.url, params);
			},
		},
		withdrawalConfig: {
			url: `${config.API_URL}/admin/withdrawal/withdrawalConfigStore`,
			name: "提现配置",
			post: async function (params) {
				return await http.post(this.url, params);
			},
		},
	},
	platformAssets: {
		list: {
			url: `${config.API_URL}/admin/order/getPlatformAssets`,
			name: "资产与佣金",
			get: async function (params) {
				return await http.get(this.url, params);
			},
		},
	},
	getDistributionList: {
		list: {
			url: `${config.API_URL}/admin/order/getDistributionList`,
			name: "分销列表",
			get: async function (params) {
				return await http.get(this.url, params);
			},
		},
	},
	getIncomeList: {
		list: {
			url: `${config.API_URL}/admin/order/getIncomeList`,
			name: "收入明细",
			get: async function (params) {
				return await http.get(this.url, params);
			},
		},
	},
	order: {
		list: {
			url: `${config.API_URL}/admin/order/index`,
			name: "订单列表",
			post: async function (params) {
				return await http.post(this.url, params);
			},
		},
		store: {
			url: `${config.API_URL}/admin/order/paymentSettlement`,
			name: "订单结款",
			post: async function (params) {
				return await http.post(this.url, params);
			},
		},
	},
};
